var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5774 27.3409L14.6321 25.2863",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5774 25.2862L14.6321 27.3409",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.231 21.3729L24.2856 23.4276",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2856 21.373L22.231 23.4276",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16479 17.9916L9.21949 15.9369",
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16479 15.9369L9.21948 17.9916",
    stroke: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.9784L20.9784 11",
    stroke: "currentColor",
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9784 11L21.9568 11.9784",
    stroke: "currentColor",
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4683 12.5123L15.523 10.4576",
    stroke: "currentColor"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4683 10.4576L15.5229 12.5123",
    stroke: "currentColor"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8764 3.59802H7.88647C5.26312 3.59802 3.13647 5.72467 3.13647 8.34802V26.3744C3.13663 28.9976 5.26322 31.1244 7.88647 31.1244H23.1843C25.8076 31.1244 27.9342 28.9976 27.9343 26.3744V8.34802C27.9343 5.72467 25.8077 3.59802 23.1843 3.59802H20.2878V4.36147L20.2875 4.75284V5.09802H23.1843C24.9793 5.09802 26.4343 6.5531 26.4343 8.34802V26.3744C26.4342 28.1692 24.9792 29.6244 23.1843 29.6244H7.88647C6.09164 29.6244 4.63663 28.1692 4.63647 26.3744V8.34802C4.63648 6.5531 6.09155 5.09802 7.88647 5.09802H10.876V4.75284L10.8764 4.36656V3.59802Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.65027V3.6986C19.9977 3.45839 19.7981 3.26508 19.5544 3.26508H19.4928C18.1395 3.26508 16.8534 2 15.5002 2C14.147 2 12.8608 3.26508 11.5076 3.26508H11.4459C11.1999 3.26508 11.0004 3.46182 11.0004 3.70431V4.65598L11 5.0895V5.56077C11 5.80326 11.1996 6 11.4456 6H19.5553H19.5542C19.8001 6 19.9997 5.80326 19.9997 5.56077V5.0895L20 4.65027Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12V11.5",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 21,
    r: 1,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategy);
export default __webpack_public_path__ + "static/media/strategy.94a5557062ec992bbfd78a6ca284aa2b.svg";
export { ForwardRef as ReactComponent };